/*
 * @Description:
 * @version:
 * @Author: guyifeng
 * @Date: 2020-09-27 15:05:46
 * @LastEditors: guyifeng
 * @LastEditTime: 2020-10-14 10:34:09
 */
import { request } from "@/helper";
import { getCookie } from "@/utils/cookie";

export const NORMAL_TOKEN_NAME = "token";
export const APP_TOKEN_NAME = "X-M-Auth-TOKEN";

// 存储 token 由于 A2-A3 使用西瓜浏览器，目前西瓜浏览器比较特殊
// 不方便拿到 cookie 和 localStorage，使用 setToken 来设置 token
export var G_DATA = { token: ''};
export function setToken(token) {
  G_DATA.token = G_DATA.token || token;
}

export function getToken() {
  return getCookie(NORMAL_TOKEN_NAME) || getCookie(APP_TOKEN_NAME) || G_DATA.token || '';
}

function resParser(res) {
  if (+res.status === 200) {
    return Promise.resolve(res.body);
  }
  return Promise.reject(res);
}

function handleError(e) {
  return Promise.reject(e);
}

export default function fetch(url, data, options = {}) {
  return request({
    ...options,
    headers: {
      ...options.headers,
      token: getToken(),
    },
    url,
    data,
  })
    .then(resParser)
    .catch(handleError);
}
